import { LinkStatsApiModel } from '../../../model/statisticsReport/link-stats-api.model';

export class LinksReportModel {
    linkStats: LinkStatsApiModel[];
    totalClicks: number;
    totalClickThroughRate: number;

    constructor(apiModel?: LinkStatsApiModel[]) {
        if (apiModel) {
            this.linkStats = [...apiModel];
            this.totalClicks = 0;
            this.linkStats.forEach(x => this.totalClicks += x.clickCount);
        }
    }

    calculateClickThroughRates(uniqueOpenCount: number): void {
        this.linkStats.forEach(link => {
            link.clickThroughRate = uniqueOpenCount ? link.uniqueClickCount / uniqueOpenCount : 0;
        });
    }
}
